import React, { ReactNode, useContext, useEffect, useState } from 'react'
import { IntegrationContext, IntegrationContextPayload } from '../../../../../context/integrationContext';
import { UserContext, UserContextPayload } from '../../../../../context/userContext';
import styles from "../../../../../assets/styles/componentStyles/template.module.scss";
import noDataFound from '../../../../../assets/CampaignNoDataFound.png'
import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import GlobalButton from '../../../../utility/globalButton/button'; 
import DeleteIcon from '@mui/icons-material/Delete';
import GlobalPopUp from '../../../../utility/globalPopUp';
import GlobalDeletePopup from '../../../../utility/globalDeletePopup/globalDeletePopup';
import { ChatbotContext, ChatbotContextPayload } from '../../../../../context/chatbotContext';
import dashboardStyles from '../../../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisDashboard.module.scss';
import { zohoContact, zohoDepartment, zohoTicketLogs } from '../../../../../models/axiosModel';
import EmptyState from '../../../../global/emptyState';

interface ZohoTicketLogsProps {
    zoho_integration_id: number,
} 

const ZohoTicketLogs: React.FC<ZohoTicketLogsProps> = (props) => {

    const {zoho_integration_id} = props;
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload; 
    const { chatBotDetails, GetChatbotDataApi } = useContext(ChatbotContext) as ChatbotContextPayload;
    const {getZohoTicketLogsApi, zohoTicketLogs, deleteZohoIntegrationChatbotAssignmentApi, zohoContact, zohoDepartment} = useContext(IntegrationContext) as IntegrationContextPayload; 
    
    const innerHeight = (window.innerHeight - 220);

    const getZohoTicketLogsApiCall = async (zoho_integration_id: number) => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }));
        const res = await getZohoTicketLogsApi(zoho_integration_id);
        if(!(res.status)){
            handleError(res);
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
    }

    useEffect(() => { 
        getZohoTicketLogsApiCall(zoho_integration_id);
    }, []);

    const convertCamelCaseToTitleCase = (str: string) => {
        return str.replace(/([A-Z])/g, " $1").replace(/^./, str => str.toUpperCase());
    }

  return (
    <>
        {
            (!zohoTicketLogs) ? 
            <></>
            : 
            (zohoTicketLogs.length > 0) ? 
                <>
                    <TableContainer sx={{ borderRadius: "5px", border: "1px solid #E9E9E9", maxWidth: "100%", overflow: "auto", boxSizing: "border-box", maxHeight: `${innerHeight}px !important`, position: "relative", zIndex: "2", marginTop: "12px" }}>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    {Object.entries(JSON.parse(zohoTicketLogs[0].zoho_ticket_payload)).map(([key, value]: [string, any], ind: number) => {
                                        return (
                                            <TableCell key={ind} className={dashboardStyles.tableBodyHeadingFontStyle}>{convertCamelCaseToTitleCase(key)}</TableCell>
                                        );
                                    })}
                                </TableRow>
                            </TableHead> 
                            <TableBody>
                                {zohoTicketLogs.map((ticket: zohoTicketLogs, ind: number) => {
                                    return (
                                        <TableRow className={dashboardStyles.cellRow} key={ind}>
                                            {Object.entries(JSON.parse(ticket.zoho_ticket_payload)).map(([key, value]: [string, any], index: number) => {
                                                return (
                                                    <TableCell key={index} className={dashboardStyles.tableBodySubHeadingFontStyle}>
                                                        {value ? value : "-"}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </> 
                : 
                <Grid item xs={12} className={styles.noDataFoundItem}>
                    <EmptyState
                        height={'calc(100vh - 250px) !important'}
                        pageIcon={<img alt="chatbot" src={noDataFound} />}
                        pageText={"No ticket generated yet!"}
                    />
                </Grid>
        }
    </>
  )
}

export default ZohoTicketLogs
